export enum CarouselSlideType {
    IMAGE = 'image',
    VIDEO = 'video'
}

export default CarouselSlideType;
